<template>
   <section class="wysiwyg" ref="el">
      <h3 v-if="headline" class="wysiwyg-headline toc-headline">
         {{ headline }}
      </h3>
      <slot></slot>
      <div class="wysiwyg-wrapper" v-html="content"></div>
   </section>
</template>

<script setup lang="ts">
const { hook } = useNuxtApp();
const el = useTemplateRef("el");
const { initWatchers } = useWYSIWYG();
const emit = defineEmits(["ready"]);
const props = defineProps({
   content: String,
   TOCType: {
      default: null,
      type: String || null,
   },
   headline: String,
});

onMounted(() => {
   emit("ready", props.TOCType, el.value);
   nextTick(() => {
      initWatchers(el.value);
   });
});
onUpdated(() => {
   nextTick(() => {
      // initWatchers(el.value);
   });
});
</script>

<style lang="scss">
@import "~/assets/scss/globals/wysiwyg";
@import "~/assets/scss/globals/tables";
@import "~/assets/scss/globals/custom_blocks";
@import "~/assets/scss/globals/audio-player";
@import "~/assets/scss/globals/inline-audio-player";
@import "~/assets/scss/globals/video-player";
</style>
